import { render, staticRenderFns } from "./folio.vue?vue&type=template&id=766a2e0f&scoped=true&"
import script from "./folio.vue?vue&type=script&lang=js&"
export * from "./folio.vue?vue&type=script&lang=js&"
import style0 from "./folio.vue?vue&type=style&index=0&id=766a2e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a2e0f",
  null
  
)

export default component.exports